import { useGetRequest } from "@ch/api/useGetRequest";
import { UserSubscriptionsControllerService } from "@ch/generated";
import { useAppSelector } from "@ch/redux-store/hooks/useAppSelector";

const useGetUserSubscriptions = () => {
  const user = useAppSelector((state) => state.user.currentUser);

  const {
    data: subscriptions = [],
    loading,
    refetch,
    status,
  } = useGetRequest({
    service:
      UserSubscriptionsControllerService.userSubscriptionsControllerGetUserSubscriptions,
    tag: "userSubscriptionsControllerGetUserSubscriptions",
    payload: { userId: user?.id ?? "" },
  });

  return {
    loading,
    subscriptions,
    refetchSubscriptions: refetch,
    status,
  };
};

export default useGetUserSubscriptions;
